import { useMutation } from '@tanstack/react-query';

import { dashboardApi } from '../../api/dashboard.api';

export interface UploadYieldMapParams {
  file: File;
  farm: number;
  yield_float: number;
  comment: string;
}

export function useUploadYieldMap() {
  return useMutation({
    mutationFn: dashboardApi.uploadYieldMap,
  });
}

export default useUploadYieldMap;
